var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isModalStatus
    ? _c("div", [
        _c("div", { staticClass: "withdraw_modal" }, [
          _c("div", { staticClass: "withdraw_overlay" }),
          _c("div", { staticClass: "withdraw_modal_position text-center" }, [
            _c(
              "div",
              { staticClass: "d-inbl", staticStyle: { "z-index": "11" } },
              [
                _c("div", { staticClass: "mb-5 withdraw_container" }, [
                  _c("img", {
                    staticClass: "w-100",
                    attrs: {
                      src: `${_vm.$s3}/img/common/login/new_logo.svg?${_vm.$ver}`,
                    },
                  }),
                ]),
                _c("div", {
                  staticClass: "text big d-inbl",
                  domProps: { innerHTML: _vm._s(_vm.$t(_vm.first)) },
                }),
                _c("div", {
                  staticClass: "text small mt-3",
                  domProps: { innerHTML: _vm._s(_vm.$t(_vm.second)) },
                }),
                _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c(
                      "b-button",
                      {
                        style: {
                          background: "#0a57d4",
                          borderRadius: "50px",
                          color: "#fff",
                          border: 0,
                          padding: !_vm.isMobile ? "10px 30px" : "5px 15px",
                          "font-weight": 400,
                          "font-size": !_vm.isMobile ? "1rem" : "12px",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.isWithDraw()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("modal.confirm")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }